// Single source of truth for per-route <title> and meta description.
//
// It has to be shared, not duplicated: usePageMeta sets these in the browser
// from an effect, which never runs during prerendering, so scripts/prerender.mjs
// imports this same map to write the tags into the static HTML. If the two ever
// drift, crawlers and users see different titles.
import { SERVICE_AREAS } from './serviceAreas';
import { SERVICE_PAGES } from './servicePages';

export const SITE_URL = 'https://onechoicetreeservice.com';

export const PAGE_META = {
  '/': {
    title: 'Tree Removal & Trimming in Maryland - Free Estimates | One Choice Tree Service',
    description:
      'Tree removal, trimming & storm cleanup across Anne Arundel, Howard, Baltimore & Carroll counties, MD. Licensed & insured. Free quotes: (443) 208-0747.',
    priority: '1.0'
  },
  '/services': {
    title: 'Tree Removal, Trimming & Emergency Services | One Choice Tree Service',
    description:
      'Tree removal, trimming & pruning, stump grinding, lot clearing, and 24/7 emergency storm response in Maryland. Free quotes: (443) 208-0747.',
    priority: '0.9'
  },
  '/contact': {
    title: 'Contact Us | Free Tree Service Quotes | One Choice Tree Service',
    description:
      'Get a free tree service quote in Maryland. Call (443) 208-0747 or send a request online — 24/7 emergency response for storm damage and fallen trees.',
    priority: '0.9'
  },
  '/about': {
    title: 'About Us | One Choice Tree Service — Maryland Tree Care',
    description:
      'Learn about One Choice Tree Service: a licensed & insured Maryland tree company serving the Baltimore region with tree removal, trimming, and complete cleanup.',
    priority: '0.8'
  },
  '/links': {
    title: 'Connect With Us | One Choice Tree Service',
    description:
      'Call, email, or follow One Choice Tree Service — Maryland tree removal, trimming, and 24/7 emergency service. Free quotes: (443) 208-0747.',
    priority: '0.5'
  },
  '/privacy': {
    title: 'Privacy Policy | One Choice Tree Service',
    description:
      'How One Choice Tree Service collects and uses information submitted through onechoicetreeservice.com.',
    priority: '0.3'
  },
  '/terms': {
    title: 'Terms of Service | One Choice Tree Service',
    description:
      'Terms governing use of onechoicetreeservice.com and quote requests submitted through it.',
    priority: '0.3'
  }
};

// Service landing pages get their meta from the page data, same as towns.
SERVICE_PAGES.forEach(page => {
  PAGE_META[`/${page.slug}`] = {
    title: page.metaTitle,
    description: page.metaDescription,
    priority: page.priority
  };
});

// Town pages get their meta from the area data so there's one place to edit.
SERVICE_AREAS.forEach(area => {
  PAGE_META[`/tree-service/${area.slug}`] = {
    title: area.metaTitle,
    description: area.metaDescription,
    priority: '0.7'
  };
});

export const ROUTES = Object.keys(PAGE_META);
